import FejezetDto from 'app/admin/fejezet/dto/FejezetDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class FejezetTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'fejezetTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FejezetDto)))
				.catch(reject);
		});
	}
}

export default new FejezetTableService();
